import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type RootBase from "@/pages/Root.Base.vue";

export default defineMosaicComponent<typeof RootBase>("pages/Root");
